function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var applyToAllStates = props => _objectSpread(_objectSpread({}, props), {}, {
  '&:hover': props,
  '&:focus': props
});
export var input = {
  field: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
    minWidth: 0,
    outline: 0,
    position: 'relative',
    transition: 'outline-color 0.1s ease-in-out',
    color: 'neutral.black',
    paddingX: 'none',
    background: 'transparent',
    textStyle: 'body2',
    border: 'input.enabled',
    borderRadius: 'l',
    paddingLeft: 's',
    paddingRight: 's',
    '&.small': {
      height: '40px'
    },
    '&.large': {
      height: '48px'
    },
    _focus: {
      outlineStyle: 'solid',
      outlineOffset: '2px',
      outlineColor: 'focus.focus'
    },
    _placeholder: {
      color: 'neutral.dark'
    },
    _readOnly: {
      boxShadow: 'none !important',
      cursor: 'auto',
      userSelect: 'all',
      pointerEvents: 'none',
      color: 'neutral.darker',
      border: 'input.readOnly',
      _focus: {
        border: 'input.readOnly'
      }
    },
    '&[data-view-mode="true"]': applyToAllStates({
      boxShadow: 'none !important',
      cursor: 'auto',
      userSelect: 'all',
      pointerEvents: 'none',
      color: 'neutral.black',
      border: 'input.transparent',
      paddingLeft: 'none',
      paddingRight: 'none',
      height: 'auto',
      _hover: {
        border: 'input.transparent'
      }
    }),
    _hover: {
      '&:not(:focus)': {
        border: 'input.hover',
        _hover: {
          border: 'input.readOnly'
        }
      },
      _disabled: {
        border: 'input.disabled'
      }
    },
    _disabled: applyToAllStates({
      color: 'neutral.light',
      border: 'input.disabled',
      cursor: 'default',
      _placeholder: {
        color: 'neutral.light'
      }
    }),
    _invalid: applyToAllStates({
      border: 'input.error'
    })
  }
};
export var formTextStyle = 'body2';
export var formHeight = {
  large: {
    height: '48px'
  },
  small: {
    height: '40px'
  }
};
//# sourceMappingURL=form.utils.js.map